module.exports = __webpack_public_path__ + "static/media/proposalist-logo.5e226086.svg";